import "./NursingCareInRamatGanWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import LocalServicesInMontreal from "./sections/LocalServicesInMontreal";
import PartsCategories from "./sections/PartsCategories";
import FaqSection from "./sections/FaqSection";
import FinalCtaSection from "./sections/FinalCtaSection";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareInRamatGanWithinHoursPage() {
  return <div>
      <Header />
      <Hero />
      <LocalServicesInMontreal />
      <PartsCategories />
      <FaqSection />
      <FinalCtaSection />
      <Footer />
    </div>;
}